import React from 'react';

function Payments() {
  return (
    <div>
      <div className="startinventoryOuter">
        <div className="startinventory">
          <h4>Payments</h4>
        </div>
      </div>
    </div>
  )
}

export default Payments;
